import React,{useState,useEffect}from "react";
import Message from "../message/Message";
import { useStyles } from "./styles";
import ExtraMessage from "../message/ExtraMessage";
import {
  Container,
  Paper,
  Grid,
  Typography,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  Box
} from "@material-ui/core";
import {useSelector} from 'react-redux';

const Scoreboard = () => {
  const classes = useStyles();
  const data=useSelector((state)=>state.selectedPlayers);
  const match=useSelector((state)=>state.selectedMatch);
  const [extramessage,setExtraMessage]=useState("");
  const [showExtMsg,setShowExtMsg]=useState(false);
  //console.log(data)
  const eventData=useSelector((state)=>state.events);
  let msg=`${match.info.outcome.winner} has won the match by ${match.info.outcome.by[Object.keys(match.info.outcome.by)[0]]} ${Object.keys(match.info.outcome.by)[0]}`

  const [showMsg,setShowMsg]=useState(false);
  const [disScore,setDisScore]=useState({
    runs1:0,
    inning1:"0",
    runs2:0,
    inning2:"0",
    score:JSON.parse(sessionStorage.getItem("score"))
  })


  useEffect(()=>{
    if(data.balls1.length>0){
    myFunc01();
    }
  },[data,match,eventData]);

  // data.players.forEach((player)=>{
  //   let item=data.balls1.find((ball1)=>ball1.batsman===player.player || ball1.bowler===player.player || ball1.non_striker===player.player)
  //   let item2=data.balls2.find((ball2)=>ball2.batsman===player.player || ball2.bowler===player.player || ball2.non_striker===player.player)
  //   if(item && item2){
  //     player.innings="both"
  //     console.log("player"+player.player+"from  both innings");
  //   }else if(item){
  //     player.innings="1"
  //     console.log("player"+player.player+"from innings 1");
  //   }
  //   else if(item2){
  //     player.innings="2"
  //     console.log("player"+player.player+"from innings 2");
  //   }
  //   else{
  //     player.innings="extra"
  //     console.log("player"+player.player+"is extra");
  //   }
  // })


  function isPlayerExist(player){
    const pla= data.players.find((com)=>com.player===player);
    if(pla){
      return true;
    }
    return false;
  }
  
  const initializePlayers=()=>{
    data.players.forEach((p)=>{
      p.runs=0;
      p.balls=0;
      p.out=false;
      p.non_striker=false;
      p.batsman=false;
    })
  }

  const displayInnings=(innings,players)=>{
    let myscore=disScore.score;
    let myruns=0;
    var i=0;
    initializePlayers();
   // console.log("display innings",players)
    while (i < innings.length) {
      (function(i) {
        setTimeout(function() {
          myruns=Number(myruns)+innings[i].runs.total;
          if(data.balls1[i].runs.extras!=0){
            setExtraMessage(`${Object.keys(data.balls1[i].extras)[0]} ${data.balls1[i].extras[Object.keys(data.balls1[i].extras)[0]]}`);
            setShowExtMsg(true);
            setTimeout(()=>{setShowExtMsg(false)},2000)
          }
           // to check if player is out
          const lastPlayer=data.players.find((p)=>p.batsman!=innings[i].batsman && p.non_striker!=innings[i].non_striker);
          if(lastPlayer && innings[i].inning!="0.1"){
              lastPlayer.out=true;
          }
          const player=data.players.find((p)=>p.batsman===true);
          if(player){
            player.batsman=false;
          }
          const nonstricker=data.players.find((p)=>p.non_striker===true);
          if(nonstricker){
           nonstricker.non_striker=false;
          }
          const newBatsman=data.players.find((p)=>p.player===innings[i].batsman);
            const newNonStriker=data.players.find((p)=>p.player===innings[i].non_striker);
            if(newBatsman){
              newBatsman.batsman=true;
              newBatsman.out=false;
             newBatsman.balls=Number(newBatsman.balls)+1;
            newBatsman.runs=Number(newBatsman.runs)+innings[i].runs.batsman;
            }
            if(newNonStriker){
              newNonStriker.non_striker=true;
            }
          if(innings[i].runs.batsman){
             if(isPlayerExist(innings[i].batsman)){
               const playerRole=data.players.find((p)=>p.player===innings[i].batsman);
               if(playerRole.role==="c"){
                 myscore+=2*innings[i].runs.batsman;
                 playerRole.score=playerRole.score? Number(playerRole.score) + 2* Number(innings[i].runs.batsman) : 2*Number(innings[i].runs.batsman)
               }
               else if(playerRole.role=="vc"){
                myscore+=1.5*innings[i].runs.batsman;
                playerRole.score=playerRole.score? Number(playerRole.score) + 1.5 * Number(innings[i].runs.batsman) : 1.5 *Number(innings[i].runs.batsman)
               }
               else{
                myscore= myscore+Number(data.balls1[i].runs.batsman);
                playerRole.score=playerRole.score? Number(playerRole.score) + 1 * Number(innings[i].runs.batsman) : 1 *Number(innings[i].runs.batsman)
               }
             }
          }
          if(innings[i].wicket?.fielders && isPlayerExist(innings[i].wicket?.fielders)){
            const event=eventData.find((eve)=>eve.Events==innings[i].wicket["kind"]);
            const bowler=data.players.find((p)=>p.player===innings[i].wicket?.fielders)
            if(event){
              myscore+=Number(event.Points)
              bowler.score= bowler.score? Number(bowler.score) + Number(event.Points): Number(event.Points)
            }
          }
            setDisScore({
              ...disScore,
              runs2:myruns,
              score:myscore,
               inning2:innings[i].inning
             })
             if(i==data.balls2.length){
              setTimeout(()=>{setShowMsg(true)},2000)
            }
        }, 1000*5*i)
      })(i++);
    }
  }

  var myFunc01 = function() {
    let myscore=disScore.score;
    let myruns=0;
    var i=0;

    initializePlayers();
    data.players.forEach((p)=>{
      p.score=0;
    })
    while (i < data.balls1.length) {
      (function(i) {
        setTimeout(function() {
          myruns=Number(myruns)+data.balls1[i].runs.total;
          if(data.balls1[i].runs.extras!=0){
            setExtraMessage(`${Object.keys(data.balls1[i].extras)[0]} ${data.balls1[i].extras[Object.keys(data.balls1[i].extras)[0]]}`);
            setShowExtMsg(true);
            setTimeout(()=>{setShowExtMsg(false)},2000)
          }
           // to check if player is out
          // console.log("data.playersimp",data.players)
          const lastPlayer=data.players.find((p)=>p.batsman!=data.balls1[i].batsman && p.non_striker!=data.balls1[i].non_striker);
          if(lastPlayer && data.balls1[i].inning!="0.1"){
              lastPlayer.out=true;
          }
          const player=data.players.find((p)=>p.batsman===true);
          if(player){
            player.batsman=false;
          }
          const nonstricker=data.players.find((p)=>p.non_striker===true);
          if(nonstricker){
           nonstricker.non_striker=false;
          }
          const newBatsman=data.players.find((p)=>p.player===data.balls1[i].batsman);
            const newNonStriker=data.players.find((p)=>p.player===data.balls1[i].non_striker);
            if(newBatsman){
              newBatsman.batsman=true;
              newBatsman.out=false;
             newBatsman.balls=Number(newBatsman.balls)+1;
            newBatsman.runs=Number(newBatsman.runs)+data.balls1[i].runs.batsman;
            }
            if(newNonStriker){
              newNonStriker.non_striker=true;
            }
          if(data.balls1[i].runs.batsman){
             if(isPlayerExist(data.balls1[i].batsman)){
               const playerRole=data.players.find((p)=>p.player===data.balls1[i].batsman);
               if(playerRole.role==="c"){
                 myscore+=2*data.balls1[i].runs.batsman;
                 playerRole.score=playerRole.score? Number(playerRole.score) + 2* Number(data.balls1[i].runs.batsman) : 2*Number(data.balls1[i].runs.batsman)
               }
               else if(playerRole.role=="vc"){
                myscore+=1.5*data.balls1[i].runs.batsman;
                playerRole.score=playerRole.score? Number(playerRole.score) + 1.5 * Number(data.balls1[i].runs.batsman) : 1.5 *Number(data.balls1[i].runs.batsman)
               }
               else{
                myscore= myscore+Number(data.balls1[i].runs.batsman);
             //   console.log(playerRole.score)
                playerRole.score=playerRole.score ? Number(playerRole.score) + Number(data.balls1[i].runs.batsman) : Number(data.balls1[i].runs.batsman)
               }
             }
          }
          if(data.balls1[i].wicket?.fielders && isPlayerExist(data.balls1[i].wicket?.fielders)){
            const event=eventData.find((eve)=>eve.Events==data.balls1[i].wicket["kind"]);
            const bowler=data.players.find((p)=>p.player===data.balls1[i].wicket?.fielders)
            if(event){
              console.log(`${Number(event.points)} has been scored by ${bowler.player} for wicket ${event.Events}`)
              myscore+=Number(event.Points)
              bowler.score= bowler.score? Number(bowler.score) + Number(event.Points): Number(event.Points)
            }
          }
            setDisScore({
              ...disScore,
            runs1:myruns,
            score:myscore,
            inning1:data.balls1[i].inning
          })
          if(i==data.balls1.length-1){
            setTimeout(()=>{displayInnings(data.balls2,data.players)},15*1000)
          }
        }, 1000*5*i)
      })(i++);
    }
  };


  return (
    <Container className={classes.root}>
     <Box component="div" className={classes.scoreBox}>
        <Typography variant="h6">Your score : </Typography>
        <Typography variant="h4" style={{color:'#fff'}}>{disScore.score}</Typography>
     </Box>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={12} md={9}>
          <Paper elevation={5} className={classes.paper}>
            <Typography align="left" variant="h5" className={classes.title}>
              {match.info.teams[0]}  <span>{`(${disScore.runs1}/${disScore.inning1})`}</span> Vs {match.info.teams[1]} <span>{disScore.inning2?`(${disScore.runs2}/${disScore.inning2})`:null}</span>
            </Typography>
            <Box component="div" display="flex">
            <TableContainer component={Paper} className={classes.tableContainer}>
              <Table size="small" aria-label="a dense table">
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell>Player</TableCell>
                    <TableCell align="right">B</TableCell>
                    <TableCell align="right">R</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {
               data.players.map((player,index)=>{
                 if(index<11){
                  return  <TableRow className={classes.tableRow} key={player.player}>
                  <TableCell component="th" scope="row">
                    {player.player} {player.batsman?"* ":null} {(player.batsman || player.non_striker)?`(not out)`:null}
                  </TableCell>
                  <TableCell align="right">{player.balls!==0?player.balls:null}</TableCell>
                  <TableCell align="right">{player.balls!==0?player.runs:null}</TableCell>
                </TableRow>
                 }
            })
         }
         </TableBody>
              </Table>
            </TableContainer>
            <TableContainer component={Paper} className={classes.tableContainer}>
              <Table size="small" aria-label="a dense table">
                <TableHead className={classes.tableHead}>
                  <TableRow>
                  <TableCell>Player</TableCell>
                    <TableCell align="right">B</TableCell>
                    <TableCell align="right">R</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                {
               data.players.map((player,index)=>{
                 if(index>=11){
                  return   <TableRow className={classes.tableRow} key={player.player}>
                   <TableCell component="th" scope="row">
                    {player.player} {player.batsman?"* ":null}  {(player.batsman || player.non_striker)?`(not out)`:null}
                  </TableCell>
                  <TableCell align="right">{player.balls!==0?player.balls:null}</TableCell>
                  <TableCell align="right">{player.balls!==0?player.runs:null}</TableCell>
                </TableRow>
                 }
            })
         }
                </TableBody>
              </Table>
            </TableContainer>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Paper elevation={5} className={classes.paper}>
            <Typography align="center" variant="h5" className={classes.title}>
                Selected Players
            </Typography>
            <TableContainer
              component={Paper}
              className={classes.tableContainer}
            >
              <Table size="small" aria-label="a dense table">
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell>Player</TableCell>
                    <TableCell align="right">Points</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                 {
                   data.players.map((player)=>{
                     if(player.role){
                      return  <TableRow className={classes.tableRow} key={player.player}>
                      <TableCell component="th" scope="row">{player.player}
                      </TableCell>
                      <TableCell align="right">{player.score?player.score:'0'}</TableCell>
                    </TableRow>
                     }
                   })
                 }
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>
      {showExtMsg?<ExtraMessage message={extramessage} />:null}
      {showMsg?<Message color="green" message={msg} status="success" setShowMsg={setShowMsg}/>:null}
    </Container>
  );
};

export default Scoreboard;
